<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xi"><b>THE KU KLUX<br/><span class="big">KLAN</span><br/>IN THE HEARTLAND</b></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_fm.vue?c2740160